import { platformBrowser } from '@angular/platform-browser';
import { registerLicense } from '@syncfusion/ej2-base';
import { AppModule } from './app/app.module';

registerLicense('Ngo9BigBOggjHTQxAR8/V1JHaF5cWWdCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdlWXpeeHRSR2RYWE1/V0ZWYEo=');

platformBrowser().bootstrapModule(AppModule, {
  ngZoneEventCoalescing: true,
})
  .then(() => {
    const loader = document.getElementById('page-loader');
    if (loader) {
      loader.classList.add('brk-loader-remove');
      setTimeout(() => loader.remove(), 300);
    }
  })
  .catch(err => console.error(err));


